import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { Spine } from '../../../core/classes/spine';
import { isMobile } from '../../../core/helpers/isMobile';

import { gameResourcesService } from '../../../services/gameResourcesService';

const columns = [0, 1, 2, 3, 4];
const GameBoard = observer(({ containerConfig }) => {
  const boardContainerRef = useRef(null);

  useEffect(() => {
    const boards = columns.map((_, index) => {
      const board = new Spine({ key: 'board' });
      board.boardIndex = index;
      board.x = index * (isMobile() ? 104 : 201);
      boardContainerRef.current.addChild(board);
      return board;
    });
    gameResourcesService.setBoardsSpine(boards);
  }, [boardContainerRef]);

  return <Container ref={boardContainerRef} {...containerConfig} name='GameBoard' />;
});

export default GameBoard;
